import React from 'react';
import { Link } from 'react-router-dom';

export default function HVFooter() {
  return (
    <footer className="mt-12 border-t border-border/50 py-6">
      <div className="container-main flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
        <nav className="flex flex-wrap justify-center gap-x-4 gap-y-1">
          <Link to="/datenschutz" className="hover:text-foreground transition-colors">Datenschutz</Link>
          <Link to="/impressum" className="hover:text-foreground transition-colors">Impressum</Link>
          <Link to="/agb" className="hover:text-foreground transition-colors">AGB</Link>
          <Link to="/ki-transparenz" className="hover:text-foreground transition-colors">KI-Transparenz</Link>
          <Link to="/barrierefreiheit" className="hover:text-foreground transition-colors">Barrierefreiheit</Link>
          <Link to="/kontakt" className="hover:text-foreground transition-colors">Kontakt</Link>
        </nav>
        <p>© {new Date().getFullYear()} Immoverita. Alle Rechte vorbehalten.</p>
      </div>
    </footer>
  );
}
